import {useDispatch} from "react-redux";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ExpandIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../store/hooks";
import {selectSemanticSearchHasConversation} from "../../state/select_semantic_search_has_conversation";
import {openSemanticSearchModal} from "../../state/semantic_search_modal_slice";
import {SemanticSearchOffersCountText} from "../SemanticSearchOffersCountText";

interface IProps {
    className?: string;
}

export const SemanticSearchSidebarHeader = ({className}: IProps) => {
    const dispatch = useDispatch();

    const hasConversation = useAppSelector(selectSemanticSearchHasConversation);
    const offerCount = useAppSelector((state) => state.offerList.list.count);

    return (
        <div
            className={cx(sidebarWrapper, !hasConversation && noConversation, className)}
            style={{justifyContent: !hasConversation ? "center" : "space-between"}}
        >
            <div className={cx(!hasConversation ? sidebarContentCenter : verticalCenter)}>
                <SemanticSearchOffersCountText variant="headline_5" offerCount={offerCount} />

                {!hasConversation && (
                    <Text variant="body_copy_1" as="p">
                        Powiedz nam więcej o swoich poszukiwaniach, a dopasujemy dla Ciebie najlepsze propozycje.
                    </Text>
                )}
            </div>

            <Button
                variant="outlined_secondary"
                size="small"
                className={cx(expandButton, !hasConversation && absoluteExpandButton)}
                onClick={() => dispatch(openSemanticSearchModal())}
            >
                <ExpandIcon size="1.92" />
            </Button>
        </div>
    );
};

const sidebarWrapper = css({
    display: "flex",
    gap: 2
});

const noConversation = css({
    mb: 100
});

const sidebarContentCenter = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    "& > h5": {
        textAlign: "center"
    },

    "& > p": {
        textAlign: "center"
    }
});

const verticalCenter = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& > h5": {
        textAlign: "center"
    },

    "& > p": {
        textAlign: "center"
    }
});

const expandButton = css({
    background: "var(--colors-white)",
    display: "none",
    width: 40,
    height: 40,
    minWidth: 40,
    maxWidth: 40,
    borderRadius: 1,

    md: {
        display: "flex"
    }
});

const absoluteExpandButton = css({
    position: "absolute",
    top: 3,
    right: 3,
    zIndex: 1
});
import {useDispatch} from "react-redux";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ExpandIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../store/hooks";
import {selectSemanticSearchHasConversation} from "../../state/select_semantic_search_has_conversation";
import {openSemanticSearchModal} from "../../state/semantic_search_modal_slice";
import {SemanticSearchOffersCountText} from "../SemanticSearchOffersCountText";

interface IProps {
    className?: string;
}

export const SemanticSearchSidebarHeader = ({className}: IProps) => {
    const dispatch = useDispatch();

    const hasConversation = useAppSelector(selectSemanticSearchHasConversation);
    const offerCount = useAppSelector((state) => state.offerList.list.count);

    return (
        <div
            className={cx(sidebarWrapper, !hasConversation && noConversation, className)}
            style={{justifyContent: !hasConversation ? "center" : "space-between"}}
        >
            <div className={cx(!hasConversation ? sidebarContentCenter : verticalCenter)}>
                <SemanticSearchOffersCountText variant="headline_5" offerCount={offerCount} />

                {!hasConversation && (
                    <Text variant="body_copy_1" as="p">
                        Powiedz nam więcej o swoich poszukiwaniach, a dopasujemy dla Ciebie najlepsze propozycje.
                    </Text>
                )}
            </div>

            <Button
                variant="outlined_secondary"
                size="small"
                className={cx(expandButton, !hasConversation && absoluteExpandButton)}
                onClick={() => dispatch(openSemanticSearchModal())}
            >
                <ExpandIcon size="1.92" />
            </Button>
        </div>
    );
};

const sidebarWrapper = css({
    display: "flex",
    gap: 2
});

const noConversation = css({
    mb: 100
});

const sidebarContentCenter = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    "& > h5": {
        textAlign: "center"
    },

    "& > p": {
        textAlign: "center"
    }
});

const verticalCenter = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& > h5": {
        textAlign: "center"
    },

    "& > p": {
        textAlign: "center"
    }
});

const expandButton = css({
    background: "var(--colors-white)",
    display: "none",
    width: 40,
    height: 40,
    minWidth: 40,
    maxWidth: 40,
    borderRadius: 1,

    md: {
        display: "flex"
    }
});

const absoluteExpandButton = css({
    position: "absolute",
    top: 3,
    right: 3,
    zIndex: 1
});
